import { useAppSelector } from "@app/hooks/useAppDispatch";
import { selectAuth } from "@app/redux/authSlice";

export const useAuth = () => {
  const auth = useAppSelector(selectAuth);
  return auth;
};
